<template>
  <div class="page-wrapper">
    <div class="page-toolbar">
      <div class="page-toolbar-left">
        <div class="filter-tabs">
          <button v-for="tab in filterTabs" :key="tab.v" type="button" class="filter-tab"
            :class="{ active: filterTab === tab.v }" @click="filterTab = tab.v">{{ tab.l }}</button>
        </div>
        <div class="search-box">
          <el-icon><Search /></el-icon>
          <input v-model="searchQuery" type="text" placeholder="搜索课程、教练" />
        </div>
      </div>
    </div>

    <div v-if="loading" class="loading-state">
      <el-icon class="loading-icon"><Loading /></el-icon>
      <p>加载中...</p>
    </div>

    <div v-else-if="filteredCourses.length === 0" class="empty-state">
      <el-icon><Notebook /></el-icon>
      <p>暂无课程</p>
    </div>

    <div v-else class="course-grid">
      <div class="course-card" v-for="(item, i) in filteredCourses" :key="item.courseId">
        <div class="course-card-header" :style="{ background: gradients[i % gradients.length] }">
          <span class="course-cat-tag">{{ item.category || '课程' }}</span>
          <div class="course-level-tag">{{ item.difficulty || '初级' }}</div>
        </div>
        <div class="course-card-body">
          <h3 class="course-title">{{ item.name }}</h3>
          <p class="course-coach"><el-icon><User /></el-icon>{{ item.coachName || '待定' }}</p>
          <div class="course-meta">
            <span><el-icon><Timer /></el-icon>{{ item.duration }}分钟</span>
            <span><el-icon><UserFilled /></el-icon>{{ item.capacity }}人/班</span>
            <span><el-icon><Calendar /></el-icon>{{ item.courseSchedule || '待定' }}</span>
          </div>
          <div class="course-footer">
            <span class="course-price">¥{{ item.price }}<small>/节</small></span>
            <button class="btn-book" @click="goAppointment(item)">
              <el-icon><Plus /></el-icon>预约
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Search, User, UserFilled, Timer, Calendar, Notebook, Plus, Loading } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import api from '@/api/request';

const gradients = [
  'linear-gradient(135deg,#0062FF,#3D8BFF)',
  'linear-gradient(135deg,#10B981,#34D399)',
  'linear-gradient(135deg,#EF4444,#F87171)',
  'linear-gradient(135deg,#F59E0B,#FCD34D)',
  'linear-gradient(135deg,#8B5CF6,#A78BFA)',
  'linear-gradient(135deg,#06B6D4,#22D3EE)',
];

export default {
  name: 'MemberCoursesView',
  components: { Search, User, UserFilled, Timer, Calendar, Notebook, Plus, Loading },
  data() {
    return {
      gradients,
      loading: false,
      filterTab: 'all',
      filterTabs: [
        { v: 'all', l: '全部' },
        { v: '有氧训练', l: '有氧训练' },
        { v: '力量训练', l: '力量训练' },
        { v: '瑜伽', l: '瑜伽' },
        { v: '搏击', l: '搏击' },
      ],
      searchQuery: '',
      courses: [],
    };
  },
  computed: {
    filteredCourses() {
      let list = this.courses.filter(c => c.status === 1);
      if (this.filterTab !== 'all') {
        list = list.filter(c => c.category === this.filterTab);
      }
      const q = (this.searchQuery || '').trim();
      if (!q) return list;
      return list.filter(c =>
        (c.name && c.name.includes(q)) ||
        (c.coachName || '').includes(q)
      );
    },
  },
  mounted() {
    this.loadCourses();
  },
  methods: {
    async loadCourses() {
      this.loading = true;
      try {
        const res = await api.getCourseList();
        if (res.data && res.data.code === 200) {
          this.courses = res.data.data || [];
        }
      } catch (e) {
        ElMessage.error('加载课程失败');
      } finally {
        this.loading = false;
      }
    },
    goAppointment(item) {
      this.$router.push({ path: '/appointment', query: { courseId: item.courseId } });
    },
  },
};
</script>

<style scoped>
.page-wrapper { padding: 0; background: var(--bg-base); min-height: 100vh; }
.page-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; gap: 12px; flex-wrap: wrap; }
.page-toolbar-left { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; flex: 1; }
.filter-tabs { display: flex; gap: 6px; flex-wrap: wrap; }
.filter-tab { padding: 6px 16px; border: 1px solid var(--border-color); background: var(--bg-gray); color: var(--text-secondary); border-radius: var(--radius-sm); font-size: 13px; font-weight: 500; cursor: pointer; transition: all 0.3s; }
.filter-tab:hover { border-color: var(--primary-blue); color: var(--primary-blue); }
.filter-tab.active { background: var(--primary-blue); border-color: var(--primary-blue); color: white; }
.search-box { display: flex; align-items: center; background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-md); padding: 0 12px; height: 38px; min-width: 200px; gap: 8px; transition: all 0.3s; }
.search-box:focus-within { border-color: var(--primary-blue); box-shadow: 0 0 0 3px rgba(0,98,255,0.08); }
.search-box .el-icon { color: var(--text-muted); }
.search-box input { border: none; background: transparent; color: var(--text-primary); font-size: 14px; outline: none; flex: 1; }
.search-box input::placeholder { color: var(--text-muted); }
.loading-state, .empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 0; color: var(--text-muted); gap: 12px; font-size: 15px; }
.loading-state .el-icon, .empty-state .el-icon { font-size: 48px; }
.loading-icon { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
.course-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 20px; }
.course-card { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-xl); overflow: hidden; transition: all 0.3s; }
.course-card:hover { transform: translateY(-4px); box-shadow: var(--shadow-xl); }
.course-card-header { height: 90px; display: flex; align-items: flex-start; justify-content: space-between; padding: 16px; }
.course-cat-tag { background: rgba(255,255,255,0.25); color: white; padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; backdrop-filter: blur(4px); }
.course-level-tag { background: rgba(0,0,0,0.2); color: white; padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 600; }
.course-card-body { padding: 16px; }
.course-title { font-size: 16px; font-weight: 700; color: var(--text-primary); margin: 0 0 8px; }
.course-coach { font-size: 13px; color: var(--text-secondary); display: flex; align-items: center; gap: 5px; margin: 0 0 12px; }
.course-meta { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 14px; }
.course-meta span { font-size: 12px; color: var(--text-muted); display: flex; align-items: center; gap: 4px; overflow-wrap: anywhere; }
.course-footer { display: flex; align-items: center; justify-content: space-between; }
.course-price { font-size: 20px; font-weight: 700; color: var(--primary-blue); font-family: 'Inter', sans-serif; }
.course-price small { font-size: 12px; font-weight: 400; color: var(--text-muted); }
.btn-book { display: inline-flex; align-items: center; gap: 4px; padding: 0 14px; height: 34px; background: var(--gradient-primary); color: white; border: none; border-radius: var(--radius-md); font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.3s; }
.btn-book:hover { transform: translateY(-1px); box-shadow: var(--shadow-glow); }

@media (max-width: 768px) {
  .page-toolbar-left { flex-direction: column; align-items: stretch; }
  .filter-tabs { overflow-x: auto; -webkit-overflow-scrolling: touch; flex-wrap: nowrap; padding-bottom: 4px; }
  .filter-tab { flex-shrink: 0; white-space: nowrap; }
  .search-box { min-width: 0; max-width: none; width: 100%; }
}

@media (max-width: 480px) {
  .course-grid { grid-template-columns: 1fr; gap: 14px; }
}
</style>
